<template>
  <button class="btn">
    <slot />
  </button>
</template>

<script>
export default {
  name: "AppBtn",
};
</script>

<style scoped lang="less">
@import "@/styles/_buttons.less";
</style>
